export default __webpack_public_path__ + "606a355f900ddf30d62469e1972711ea.svg";